import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from '../Dashboard.module.css';
import Sidebar from '../Sidebar';
import ProxyModeBanner from '../../../components/ProxyModeBanner';
import { useAuthApi } from '../../../hooks/useAuthApi';

export default function ClientAdminDashboard() {

  // Use logout from useAuthApi to ensure all session data is cleared
  const { logout } = useAuthApi();
  const handleLogoff = logout;

  return (
    <div className={styles.dashboardRoot}>
      <Sidebar onLogoff={handleLogoff} />
      <div className={styles.mainContent}>
        <ProxyModeBanner />
        <Outlet />
      </div>
    </div>
  );
}
